import script from "./FeatureRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureRequest.vue?vue&type=script&setup=true&lang=js"

import "./FeatureRequest.vue?vue&type=style&index=0&id=af82f0d8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af82f0d8"]])

export default __exports__